import { RoutineFilterKey } from '../domain';
import { useSetFilter } from '../../filter';

export const useSetRoutineFilter = () => {
  return useSetFilter(RoutineFilterKey, 'routineFilter', true);
};
